import React, {createContext, useState} from 'react';
import ls from 'local-storage';
import { apiCall } from "../helpers/ApiCalls";
import {  Redirect } from "react-router-dom";

export const SesionContext = createContext();


export const SesionProvider = ({children}) =>{
  function getToken (){
    const token = ls.get('token');
    if(token){
      return true;
     
    }
    else{
      return false;

    }
    
  }
  const [isAuth, setIsAuth] = useState(getToken());
  const [catProovedores, setCatProovedores] = useState([]);
  function crearSesion (data){
    ls.set('usuario',data.usuario.nombre);
    ls.set('token',data.token);
    ls.set('proveedor',data.proveedor.nombre);
    ls.set('id_proveedor',data.proveedor.id);
    if(data.proveedor.id === 0){
      ls.set('admin',1);

    }
    setIsAuth(true);
  }
 async function obtenerCatalogo (){
    await apiCall('GET','reporte/cat_proveedores').then((res)=>{
      if(res.success && res.code === 200){
        setCatProovedores(res.data);
      }
    });
    
  }
  function cerrarSesion (){
    ls.remove('token');
    ls.remove('user_id');
    ls.remove('proveedor');
    ls.remove('id_proveedor');
    ls.remove('admin');
    ls.remove('usuario');

    setIsAuth(false);
    return <Redirect to = "/"/>;

  }
  
  const value = {
    isAuth,
    catProovedores,
    obtenerCatalogo,
    crearSesion,
    cerrarSesion,
  }

  return (
    <SesionContext.Provider value = {value}>
      {children}
    </SesionContext.Provider>
  );
} 